import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    gap: theme.spacing(6),
    margin: theme.spacing(2, 0, 4),
    maxWidth: 1100,
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    maxHeight: 64,
    maxWidth: 64,
  },
}))

export default function StorageTypeLogos() {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.logo}>
        <img
          src="/ui/images/netapp.png"
          className={classes.image}
          data-testid="storage-type-logos--img-1"
        />
      </div>
      <div className={classes.logo}>
        <img
          src="/ui/images/purestorage.png"
          className={classes.image}
          data-testid="storage-type-logos--img-2"
        />
      </div>
      <div className={classes.logo}>
        <img
          src="/ui/images/dell.png"
          className={classes.image}
          data-testid="storage-type-logos--img-3"
        />
      </div>
      <div className={classes.logo}>
        <img
          src="/ui/images/3par.png"
          className={classes.image}
          data-testid="storage-type-logos--img-4"
        />
      </div>
    </div>
  )
}
